'use strict';

namespace Core {

    class ScAccordion {

        // Bound
        title: string;

        private element: JQuery;
        private tabs: ScAccordionTab[] = [];
        private activeTab: ScAccordionTab|null;

        constructor (
            private $scope: ng.IScope
        ) {
        }

        public init (element: ng.IAugmentedJQuery): void {
            this.element = element;
        }

        public addTab (tab: ScAccordionTab): void {
            this.tabs.push(tab);
        }

        public selectTab(tab: ScAccordionTab): void {
            if (this.activeTab) {
                this.activeTab.isActive = false;
                if (tab === this.activeTab) {
                    this.activeTab = null;
                    return;
                }
            }
            tab.isActive = true;
            this.activeTab = tab;
        }
    }

    class ScAccordionTab {

        // Bound
        heading: string;
        tabId: string;

        public element: JQuery;
        public panelElement: JQuery;
        public wrapperElement: JQuery;
        public parentAccordion: ScAccordion;
        public isActive: boolean = false;

        private tabButtonId: string;
        private tabPanelId: string;

        private open: boolean = false;

        private events = {
            'click': () => {
                this.parentAccordion.selectTab(this);
            }
        };

        constructor (
            private $scope: ng.IScope,
            private animationUtil: any
        ) {
        }

        public init (element: ng.IAugmentedJQuery,
                     panelElement: ng.IAugmentedJQuery,
                     accordion: ScAccordion): void {

            this.element = element;
            this.panelElement = panelElement;
            this.wrapperElement = panelElement.children().first();
            this.parentAccordion = accordion;

            // Add tab to the accordion
            this.parentAccordion.addTab(this);

            if (this.tabId === undefined) {
                throw 'tabId not specified for ScAccordionTab';
            }

            this.tabButtonId = `accordion-tab-${this.tabId}`;
            this.tabPanelId = `accordion-tabpanel-${this.tabId}`;

            this.panelElement.css({height: `0px`});

            // watch `active` state
            this.$scope.$watch('tab.isActive', (val) => {
                if (!_.isUndefined(val)) {
                    val ? this.handleOpen() : this.handleClose();
                }
            });
        }

        private handleOpen(): void {
            if (this.open) {
                return;
            }

            // animate the panel IN
            this.open = true;

            this.panelElement.css({height: `${this.wrapperElement[0].clientHeight}px`});
            this.animationUtil.waitForTransition(this.element).then((el) => {
                this.panelElement.css({height: 'auto'});
            });
        }

        private handleClose(): void {
            if (!this.open) {
                return;
            }

            // animate the panel OUT
            this.open = false;

            this.panelElement.css({height: `${this.wrapperElement[0].clientHeight}px`});
            setTimeout(() => {
                this.panelElement.css({height: `0px`});
            });
        }
    }


    angular
        .module('core')
        .directive('scAccordion', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                controller: ScAccordion,
                controllerAs: 'accordion',
                bindToController: {
                    title: '@'
                },
                template:
                    `<ul class="sc-c-option-list"
                            role="tablist"
                            id="{{accordion.title.toLowerCase().replace(' ', '-')}}"
                            ng-attr-aria-label="{{accordion.title || undefined}}"
                            ng-transclude>
                     </ul>`,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: ScAccordion
                ) => {
                    controller.init(el);
                }
            };
        })
        .directive('scAccordionTab', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                require: '^scAccordion',
                replace: true,
                transclude: true,
                controller: ScAccordionTab,
                controllerAs: 'tab',
                bindToController: {
                    heading: '@',
                    tabId: '@'
                },
                template:
                    `<span>
                        <div
                            role="tab"
                            class="sc-c-option"
                            ng-click="tab.events.click($event)"
                            id="{{tab.tabButtonId}}"
                            aria-selected="{{tab.isActive}}"
                            aria-controls="{{tab.tabPanelId}}"
                            ng-attr-tabindex="{{tab.isActive ? undefined : '-1'}}"
                        >
                            <div class="sc-c-option__primary-content">
                                <span class="star-rating sc-u-color-primary sc-u-bold">
                                    {{tab.heading}}
                                </span>
                            </div>
                            <sc-svg-inline
                                ng-if="!tab.isActive"
                                name="chevron-down"
                                class="sc-o-svg-icon sc-o-svg-icon--xs sc-c-option__action-icon"
                            />
                            <sc-svg-inline
                                ng-if="tab.isActive"
                                name="chevron-up"
                                class="sc-o-svg-icon sc-o-svg-icon--xs sc-c-option__action-icon"
                            />
                        </div>
                        <div
                            role="tabpanel"
                            id="{{tab.tabPanelId}}"
                            ng-style="{
                                minHeight: '0px',
                                overflow: 'hidden',
                                transition: 'height 300ms linear',
                            }"
                        >
                            <div ng-style="{display: 'flex'}" class="sc-u-padding-x-m" ng-transclude />
                        </div>
                    </span>
                    `,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    accordionCtrl: ScAccordion
                ) => {
                    scope.tab.init(el, el.find('[role=tabpanel]'), accordionCtrl);
                }
            };
        });
}

